var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('p',{staticClass:"stripeProductPreview"},[_c('strong',[_vm._v(_vm._s(_vm.product.name)+" Plan")]),_c('br'),_vm._v(" "+_vm._s(_vm.product.description)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }